import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const generateApiKey = (company_id, name) => {
  return axios.post(API + "company/api-keys/generate/", { company_id, name }, { headers: authHeader() });
};

const listApiKeys = () => {
  return axios.get(API + "company/api-keys/", { headers: authHeader() });
};

const revokeApiKey = (pk) => {
  return axios.delete(API + `company/api-keys/${pk}/revoke/`, { headers: authHeader() });
};

const ApiKeyService = { generateApiKey, listApiKeys, revokeApiKey };
export default ApiKeyService;
